/**
 * Settingscontext.jsx
 * Persists volume, sfxEnabled, and musicEnabled to localStorage
 * so settings survive a browser refresh.
 */
import { createContext, useContext, useState, useEffect } from 'react';

const SETTINGS_KEY = 'prismpals_settings_v1';

function loadSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

function saveSettings(s) {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
  } catch (_) {}
}

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const saved = loadSettings();

  const [isOpen,       setIsOpen]       = useState(false);
  const [volume,       setVolume]       = useState(saved?.volume       ?? 70);
  const [sfxEnabled,   setSfxEnabled]   = useState(saved?.sfxEnabled   ?? true);
  const [musicEnabled, setMusicEnabled] = useState(saved?.musicEnabled ?? true);

  /* Persist whenever any setting changes */
  useEffect(() => {
    saveSettings({ volume, sfxEnabled, musicEnabled });
  }, [volume, sfxEnabled, musicEnabled]);

  const openSettings  = () => setIsOpen(true);
  const closeSettings = () => setIsOpen(false);

  return (
    <SettingsContext.Provider value={{
      isOpen, openSettings, closeSettings,
      volume,       setVolume,
      sfxEnabled,   setSfxEnabled,
      musicEnabled, setMusicEnabled,
    }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);